import { render, staticRenderFns } from "./treaty.vue?vue&type=template&id=441025de&scoped=true"
import script from "./treaty.vue?vue&type=script&lang=js"
export * from "./treaty.vue?vue&type=script&lang=js"
import style0 from "./treaty.vue?vue&type=style&index=0&id=441025de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441025de",
  null
  
)

export default component.exports